/* src/app/components/source-select/source-select.component.scss */
.head {
  color: white;
  padding: 9px 10px;
  position: relative;
  background: #007c91;
  border: 1px solid #007c91;
  min-height: 56px;
}
.right-panel {
  margin-left: 15px;
}
.container-height-calc {
  height: calc(100% - 158px);
  border: 0 !important;
  padding: 0;
  margin: 0;
}
.row-head,
.height-100 {
  height: 100%;
}
.row-head {
  border: 1px solid #e0e7e9;
}
.main-content .split-panel {
  flex: 0 0 50%;
  max-width: 50%;
}
.search-container,
.close-icon {
  position: relative;
}
.search-container .clear-input,
.close-icon .clear-input {
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  padding: 2px 0 0;
}
.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  top: 16px;
  right: -35px;
  cursor: pointer;
}
.close-icon:after {
  content: "X";
  display: block;
  width: 15px;
  height: 15px;
  position: absolute;
  background-color: #fa9595;
  z-index: 1;
  right: 43px;
  top: 0;
  bottom: 0;
  margin: auto;
  padding: 0px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: normal;
  font-size: 12px;
  box-shadow: 0 0 2px #e50f0f;
  cursor: pointer;
}
.search-div {
  display: inline-block !important;
  width: 300px !important;
  margin-left: 155px !important;
  margin-top: 1px !important;
}
.filter-btn {
  border: 1px solid;
  padding: 0 15px;
  margin: -1px;
  font-size: 16px;
}
@media (max-width: 575px) {
  .filter-btn {
    background-image: url("./media/filter-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
    font-size: 0;
    padding: 16px 18px;
  }
}
.filter-btn:focus {
  outline: 0 !important;
}
.filterDiv:focus {
  outline: 0 !important;
}
.filterDiv {
  left: -7px !important;
}
.width-100 {
  width: 100% !important;
}
.left-48 {
  left: 48px;
  margin-top: 7px;
}
.top-8 {
  margin-top: 8px;
}
.margin-7 {
  margin-bottom: -7px;
}
.top-7 {
  margin-top: -7px;
}
.padding-left-24 {
  padding-left: 24px;
}
.margin-top-7 {
  margin-top: 7px;
}
.fixed-min-width-content {
  flex: 1;
  min-width: 0;
}
.fixed-min-width-button {
  min-width: 86.65% !important;
}
.fixed-max-width-checkbox {
  flex: 0 0 50px;
  max-width: 50px;
}
.padding-1 {
  padding: 1px !important;
}
.top-12 {
  margin-top: 12px;
}
.top-11 {
  margin-top: 11px;
}
.top-7 {
  margin-top: 7px;
}
.right-panel-select-checkbox {
  margin-top: -15px;
  width: 30px;
}
.bottom-9 {
  margin-bottom: 9px;
}
.question-create {
  position: relative;
  display: inline-block;
  padding: 0 !important;
}
.fixed-display {
  position: fixed;
}
.right-expand-div {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.fullscreen-toggle {
  display: none;
}
@media (min-width: 769px) and (min-height: 551px) {
  .fullscreen-toggle {
    display: block;
  }
}
.padding-bottom-5 {
  padding-bottom: 5px;
}
.handPointer {
  width: 23px;
  position: relative;
  top: 4px;
  cursor: pointer;
}
.head-right {
  margin-top: 9px;
}
.row-head-right {
  background: #e0e7e9;
  border-bottom: 1px solid #e0e7e9;
  padding: 10px 10px 10px 0;
  position: relative;
}
.question-div {
  top: 7px;
  padding-left: 5px !important;
}
.padding-left-10 {
  padding-left: 10px !important;
}
.padding-left-20 {
  padding-left: 20px !important;
}
.collapse-btn-right {
  position: relative;
  right: 9px;
}
.collapse-btn-right-success {
  position: relative;
  right: 6px;
}
.remove-btn {
  position: relative;
  left: 11px;
}
.remove-btn-success {
  position: relative;
  left: 6px;
}
.handles {
  cursor: move;
}
.head-checkbox {
  position: relative;
  top: 74px;
}
.left-draw {
  position: relative;
  left: -10px;
  top: -10px;
  height: fit-content;
  margin-top: 74px;
}
.left-checkbox {
  position: relative;
  top: -12px;
  left: -19px;
}
.left-panel-div {
  padding-left: 5px !important;
  padding-top: 10px;
}
.left-panel-div .row {
  margin-bottom: 8px;
}
.left-panel-div .row .kebab-wrapper {
  margin-left: auto;
}
.left-panel-div .question-row {
  display: flex;
}
.left-panel-div .question-row .question-main-content {
  flex-grow: 1;
  max-width: 79%;
}
.left-panel-div .question-row .points-div {
  display: flex;
  justify-content: end;
  max-width: 21%;
}
.left-panel-div .question-row .points-div .select-point {
  width: 85%;
}
.align-thumb {
  margin-left: 6px;
  position: relative;
}
.border-div {
  background: #fff;
  border-bottom: 1px solid #d1dbde;
}
.bodyRow {
  overflow-y: auto;
  overflow-x: hidden;
}
.pill-btn {
  border-radius: 20px;
  padding: 0 10px;
  height: 30px;
  display: flex;
  align-items: center;
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  pointer-events: none;
  line-height: 12px;
  color: #fff !important;
  background-color: #337ab7 !important;
  border-color: #2e6da4 !important;
}
.testTable {
  table-layout: fixed;
}
.testTable th:nth-child(2) {
  width: 8em;
}
.testTable th {
  background: #007c91;
  color: #fff;
}
.testTable td {
  color: #46707d;
}
.checkbox-multipart {
  padding-top: 35px;
}
.margin-top-10 {
  margin-top: 10px;
}
.height-20 {
  height: 20px !important;
  position: relative;
  display: inline-flex;
}
.points-padding {
  padding-right: 0;
  left: 10px;
  top: 5px;
}
.question-margin {
  padding: 0;
  top: 5px;
}
.question-edit {
  width: 19px;
  padding: 0;
  top: -3px;
}
.points-padding-multipart {
  padding-right: 0;
  top: -5px;
  left: 0px;
}
.title-question {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #222222;
}
.margin-left-10 {
  margin-left: 10px;
}
.margin-right-7 {
  margin-right: 7px;
}
.question-head {
  font-family: "proxima_novaregular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  top: -1px !important;
  color: black;
}
.question-bank-header {
  height: auto;
  min-height: 60px;
  display: flex;
  text-align: center;
  row-gap: 10px;
}
.fix-right {
  position: absolute;
  right: 20px;
  top: 8px;
}
.m-adj-top {
  margin: 11px 0 !important;
}
.padding-right-20 {
  padding-right: 20px !important;
}
.margin-top-6 {
  margin-top: 6px;
}
.no-ques,
.drop-hint {
  display: inline-block;
  margin: auto;
  font-weight: 700;
  color: black;
}
.fixed-bottom {
  position: fixed;
  bottom: 0;
  z-index: 1001;
}
.select-div-multipart {
  padding-right: 0px;
  margin-right: -17px;
  margin-top: 209px;
}
.select-div {
  padding-right: 0px;
}
.padding-right-16 {
  padding-right: 16px !important;
}
.padding-right-15 {
  padding-right: 15px !important;
}
.exam-statistics-text {
  font-size: 14px;
}
.margin-right-10 {
  margin-right: 10px;
}
.inline-block-element {
  display: inline-block;
  left: 2px;
  position: relative;
}
.modal-dialog-copy {
  width: 500px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1010;
  margin: 0px auto;
  transform: translate(-50%, -50%);
}
.modal-header-new {
  background-color: #174d5c;
  color: #fff;
  height: 45px;
  padding: 12px 18px 12px 30px;
}
.modal-header-new .modal-title {
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
}
.div-cont {
  display: flex;
  gap: 10px;
}
.child-cont-1 {
  float: left;
  width: 24px;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px;
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background-color: #f0f3f4;
}
.child-cont-2 {
  float: left;
  width: 90%;
  color: black;
}
.center-align {
  display: flex;
  align-items: center;
}
.new-top-head {
  padding: 0;
  margin-top: -6px;
  margin-bottom: 1px;
}
.change-source-div {
  display: block;
}
.padding-head {
  padding: 15px 30px 0 30px !important;
}
.margin-right-settings {
  margin-right: 90px;
}
.updatePointsInputStyle {
  width: 310px;
}
::ng-deep .ahe-ui-checkbox > input[type=checkbox] + span::before {
  background-color: white;
}
::ng-deep #kebabMenu .dropdown-menu li a.dropdown-item {
  padding: 8px !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-preview {
  box-shadow: 0px 8px 20px 0px rgba(42, 44, 46, 0.0588235294);
  background: white;
  border-radius: 6px;
  overflow: hidden;
}
.cdk-drag-preview:not(:has(.fa-thumb-tack)) .drag-handle-div {
  background-color: #265867;
  border: 1px solid white;
  outline: 1px solid #265867;
}
::ng-deep #rightList.cdk-drop-list-dragging #test-panel ~ .cdk-drag-placeholder {
  height: 0 !important;
}
.section-heading {
  margin: 0 0 5px 0;
  color: #46707d;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.selected-questions-list {
  padding: 0;
  margin-bottom: 5px;
}
.panel-title {
  font-size: 16px;
  margin: 0;
  font-weight: 700;
  color: white;
}
.panel-title span {
  font-weight: 400;
}
.clear-input {
  position: relative;
}
.question-type-container {
  gap: 1.5rem;
  display: flex;
  align-items: center;
}
.question-type-container .handPointer {
  top: 0;
}
.right-panel-container {
  padding: 10px 12px;
}
.grabbed-state {
  background-color: #265867;
  border: 1px solid white;
  outline: 1px solid #265867;
}
.padding-top-74 {
  padding-top: 74px;
}
.drop-zone-highlight {
  background-color: #CCEEF8;
}
.drop-hint {
  color: #61676B;
  font-weight: 400;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.multipart-select-checkbox {
  display: block;
  width: 20px;
  position: relative;
  left: -9px;
}
.add-from-header {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.add-from-header .panel-title {
  padding-right: 5px;
}
.close {
  height: 20px;
  width: 20px;
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  filter: alpha(opacity=30);
}
.remove-modal-container {
  display: flex;
}
.remove-modal-container app-checkbox {
  margin-top: -6px;
}
.question-count-span {
  margin-left: 6px;
}
[for=updatePointsInput] .required {
  color: #686E72;
  font-size: min(85%, 12px);
}
@media (min-width: 576px) {
  .add-from-header {
    flex-direction: row;
  }
}
@media (min-width: 768px) and (max-width: 912px) {
  .add-from-header {
    margin-top: 2px;
    flex-direction: column;
  }
  .head:has(.add-from-header) {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
@media (max-width: 430px), (min-width: 768px) and (max-width: 835px) {
  .display-text .question-type-container {
    flex-direction: column;
  }
}
@media (max-width: 640px), (min-width: 768px) and (max-width: 1030px) {
  .left-panel-div .question-row {
    flex-direction: column;
  }
  .left-panel-div .question-row .question-main-content {
    max-width: 100%;
  }
  .left-panel-div .question-row .points-div {
    justify-content: start;
    max-width: 100%;
  }
}
@media (max-width: 768px), (max-height: 550px) {
  .container-height-calc .main-content {
    padding-bottom: 60px;
  }
}
@media (max-height: 550px), (max-width: 768px) {
  .main-content .split-panel {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 575px) {
  #sbDeleteModal .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  #sbDeleteModal .modal-overlay .modal-container-new {
    max-width: 90vw;
    display: flex;
  }
  #sbDeleteModal .modal-overlay .modal-container-new .modal-dialog-copy {
    width: 100%;
    position: static;
    transform: none;
  }
  #sbDeleteModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content {
    height: fit-content;
    max-height: 100%;
  }
  #sbDeleteModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-new {
    overflow-x: hidden;
    padding: 16px 12px 16px 7px;
    width: 100%;
  }
  #sbDeleteModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
@media (max-width: 767px) {
  .testTable th:first-child {
    width: unset;
    min-width: unset;
    max-width: unset;
  }
}
/*# sourceMappingURL=source-select.component.css.map */
